import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Parallax {
  constructor() {
    this.pointer = document.querySelector('[data-hook=parallax-pointer]');
    if (!this.pointer) return;

    gsap.registerPlugin(ScrollTrigger);
    this.init();
  }

  init() {
    let trigger = document.querySelector('.main')

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: trigger,
        start: `top top`,
        end: `top top-=100px`,
        scrub: true
      }
    })

    tl.to(this.pointer, {
      opacity: 0
    })
  }
}
